import React, {useState, useMemo} from 'react';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import moment from 'moment';

const AppDateRange = ({ rangeDate = [], onChange, inputFormat = 'MM/dd/yyyy', justifyContent = "start", alignItems = "center", display="flex", size="small" }) => {
    const [startDate, setStartDate] = useState(rangeDate[0] || new moment());
    const [endDate, setEndDate] = useState(rangeDate[1] || new moment().add(1, 'month'));

    const isInvalid = useMemo(() => new moment(endDate).isBefore(startDate), [startDate, endDate])

    const handleChangeStart = (value) => {
        setStartDate(value);
        triggerOnChange([value, endDate]);
    }

    const handleChangeEnd = (value) => {
        setEndDate(value);
        triggerOnChange([startDate, value]);
    }

    const triggerOnChange = ([start, end]) => {
        const isInvalidLocal = new moment(end).isBefore(start);
        if(isInvalidLocal){ return; }
        onChange?.([start, end]);
    }

    return(
        <>
            <Box flex={1} alignItems={alignItems} display={display} sx={{ pt: 3, pb: 3 }} justifyContent={justifyContent}>
                <DesktopDatePicker
                    sx={{ backgroundColor: '#fff' }}
                    label="Start Date"
                    inputFormat={inputFormat}
                    value={startDate}
                    onChange={handleChangeStart}
                    renderInput={(params) => <TextField {...params} size={size} error={isInvalid} sx={{ bgcolor: 'background.paper', borderRadius: 2 }} />}
                />
                <Box sx={{ pl: 2, pr: 2 }}> 
                    To
                </Box>
                <DesktopDatePicker
                    label="End Date"
                    inputFormat={inputFormat}
                    value={endDate}
                    onChange={handleChangeEnd}
                    renderInput={(params) => <TextField {...params} size={size} error={isInvalid} sx={{ bgcolor: 'background.paper', borderRadius: 2 }} />}
                />
            </Box>
            
            {
                isInvalid && 
                    <Box sx={{ color: 'red', mb: 3 }} alignItems="center" display="flex"  justifyContent={justifyContent}>
                        Invalid date range.
                    </Box>
            }
        </>
    )
}

export default AppDateRange;